module.exports = __webpack_public_path__ + "static/media/brian_english_british.97b11279.mp3";